import React from "react";
import Grid from "@mui/material/Grid";
import MentorGridBox from "../mentor/components/mentor_box";
import styles from "./counsellor_list_grid.module.scss";
import { useRecoilValue } from "recoil";
import { authAtom } from "@_recoil/_state";
import { useRouter } from "next/router";
import { useSystemActions } from "@_recoil/_actions";

export const CounsellorListGrid = ({ counsellor }) => {
  return (
    <section className={styles.section_mentor_list_grid}>
      <div className="container">
        <div className={styles.heading_wrapper}>
          <h2>Our Team of Experts</h2>
          <p className={`font-medium`}>
            UniSearch’s dedicated team of global counsellors have years of
            experience helping students like you turn their study abroad dreams
            into reality.
          </p>
        </div>
        {/* <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12}>
            <h2>Our Team of Experts</h2>
            <p className={`font-medium`}>
              UniSearch’s dedicated team of global counsellors have years of
              experience helping students like you turn their study abroad
              dreams into reality.
            </p>
          </Grid>
          <Grid
            item
            xs={12}
            sm={4}
            md={6}
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="flex-end"
          >
            <button className="btn btn-outline">All Counsellors</button>
          </Grid>
        </Grid> */}
        <Grid
          sx={{ marginTop: 2 }}
          container
          spacing={3}
          justifyContent={"center"}
        >
          {counsellor?.length > 0 &&
            counsellor?.slice(0, 8).map((item, i) => (
              <Grid key={i} item xs={12} sm={6} md={4} lg={3}>
                <MentorGridBox
                  iconVerified={item?.iconVerified}
                  avatar={item?.profileImageSrc}
                  name={`${item?.firstName} ${item?.middleName} ${item.lastName}`}
                  country={item?.countryName}
                  link={item.link || ""}
                  id={item?.id}
                  type="Counsellor"
                />
              </Grid>
            ))}
        </Grid>
      </div>
    </section>
  );
};

export default CounsellorListGrid;
